import { createContext, useCallback, useContext, useMemo, useState } from 'react';

function createSheetProvider() {
  const Context = createContext(null);

  function Provider({ children }) {
    const [isOpen, setOpen] = useState(false);

    const open = useCallback(() => setOpen(true), []);
    const close = useCallback(() => setOpen(false), []);

    const value = useMemo(
      () => ({ isOpen, open, close, setOpen }),
      [isOpen, open, close],
    );

    return <Context.Provider value={value}>{children}</Context.Provider>;
  }

  function useSheet() {
    const ctx = useContext(Context);
    if (!ctx) {
      throw new Error('useSheet must be used inside its Provider');
    }
    return ctx;
  }

  return { Provider, useSheet };
}

const categorySheet = createSheetProvider();
const assetSheet = createSheetProvider();
const goalSheet = createSheetProvider();

export const CategorySheetProvider = categorySheet.Provider;
export const useCategorySheet = categorySheet.useSheet;

export const AssetSheetProvider = assetSheet.Provider;
export const useAssetSheet = assetSheet.useSheet;

export const GoalSheetProvider = goalSheet.Provider;
export const useGoalSheet = goalSheet.useSheet;
